import { NextSeo } from 'next-seo';
import PropTypes from 'prop-types';

import AssembleLayout from '@/src/layouts/AssembleLayout';
import MainLayout from '@/src/layouts/MainLayout';
import { pagePlatformDetailsByUIDGet } from '@/src/lib/prismic/queries';
import { urlHostResolver } from '@/src/lib/utils';
import PlatformDetails from '@/src/views/platform/PlatformDetails';

export default function PlatformDetailsPage({ doc, preview }) {
  const hero = doc?.data?.body?.find(slice => slice.slice_type === 'hero');
  const heroImage = hero?.primary?.image;
  const ogImage = {
    url: heroImage?.url,
    width: heroImage?.dimensions?.width,
    height: heroImage?.dimensions?.height,
    alt: heroImage?.alt,
  };

  return (
    <AssembleLayout Layout={MainLayout} Component={PlatformDetails} doc={doc} preview={preview}>
      <NextSeo
        title={`${doc?.data?.page_title}`}
        description={doc?.data?.page_description}
        openGraph={{
          title: `${doc?.data?.page_title}`,
          url: urlHostResolver(`/platform/${doc?.uid}`),
          images: [...(heroImage ? [ogImage] : [])], // TODO: Must find a more readable solution
        }}
      />
    </AssembleLayout>
  );
}

PlatformDetailsPage.propTypes = {
  doc: PropTypes.object,
  preview: PropTypes.bool,
};

export async function getStaticPaths() {
  return {
    paths: [
      'marketplace',
      'e-commerce',
      'seller',
      'pre-sales',
      'budgets',
      'concierge',
      'payment-methods',
      'payment-split',
      'payment-conciliation',
      'integrations',
      'power-ups',
      'providers',
      'orders',
      'tuition',
      'contracts',
      'catalog',
      'promotions',
      'customers',
      'logistics',
      'prices',
    ].map(item => ({
      params: { slug: item },
    })),
    fallback: false,
  };
}

export async function getStaticProps(context) {
  const { params, preview = false, previewData = {} } = context;
  const { ref } = previewData;
  const { slug: pagePlatformDetailsUid } = params;

  const doc = await pagePlatformDetailsByUIDGet({ pagePlatformDetailsUid }, { ref });
  if (!doc) return { notFound: true };

  return {
    props: { doc, preview },
    revalidate: 3600,
  };
}
